// Lightweight domain/URL validation shared by the website-check form
// (src/component/content/LeadCaptureForm.svelte) and the /api/leads endpoint.
// Accepts inputs with or without protocol/path (e.g. "example.com",
// "www.example.com", "https://example.com/path?q=1") and rejects anything that
// isn't a plausible public domain (single words, IPs, missing TLD, …).

// One or more labels (each starts/ends alphanumeric, may contain internal
// hyphens — including the double hyphen of punycode), at least one dot, and a
// TLD that is either all-alphabetic (2–63) or a punycode TLD (xn--…). IDNs work
// because the URL parser normalises them to punycode first (münchen.de → xn--…).
const DOMAIN_RE = /^(?=.{1,253}$)([a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[a-z]{2,63}|xn--[a-z0-9]{2,59})$/i;

/** Parse the hostname out of a raw user input, or null if it can't be parsed. */
export function extractHostname(value: string): string | null {
  const v = (value ?? "").trim();
  if (!v) return null;
  try {
    const url = new URL(/:\/\//.test(v) ? v : `https://${v}`);
    return url.hostname.replace(/\.$/, "");
  } catch {
    return null;
  }
}

/** True when `value` looks like a real, public domain. */
export function isValidDomain(value: string): boolean {
  const host = extractHostname(value);
  return host !== null && DOMAIN_RE.test(host);
}
